<template src="./App.html"></template>

<style lang="scss" src="./assets/_common/scss/_grid.scss"></style>
<style lang="scss" src="./assets/_common/scss/_mixins.scss"></style>
<style lang="scss" src="./assets/_common/scss/_universal.scss"></style>
<style lang="scss" src="./assets/_common/scss/_layout.scss"></style>
<style lang="scss" src="./assets/_common/scss/_breakpoints.scss"></style>
<style lang="scss" src="./App.scss"></style>

<script>
	import Header from '@/components/Header/Header';
	import Login from '@/components/Login/Login';
	import Notification from '@/components/Notification/Notification';
	import BlockNavigation from '@/components/BlockNavigation/BlockNavigation';
	import Slider from '@/components/Slider/Slider';
	import Teaser from '@/components/Teaser/Teaser';
	import List from '@/components/List/List';
	import Simple from '@/components/Simple/Simple';
	import Layer from '@/components/Layer/Layer';
	import Footer from '@/components/Footer/Footer';
	import { AdServiceInterface } from '@/services/interfaces/adServiceInterface';
	import { AdServiceHelper } from '@/services/helper/adServiceHelper';
	import { CookielascheInterface } from '@/services/interfaces/cookielascheInterface';
	import { TrackingInterface } from '@/services/interfaces/trackingInterface';
	import { TrackingConfig } from '@/config/trackingConfig';

	export default {
		name: 'App',
		components: {
			'hp-teaser': Teaser,
			'hp-block-navigation': BlockNavigation,
			'hp-header': Header,
			'hp-login': Login,
			'hp-notification': Notification,
			'hp-slider': Slider,
			'hp-list': List,
			'hp-simple': Simple,
			'hp-footer': Footer,
			'hp-layer': Layer
		},
		data () {
			return {
				teaserWidth: 300,
				colCount: 3,
				prevColCount: 0,
				dynamicMiddle: false,
				dynamicSides: false,
				fallback: false,
				sticky: false,
				gridRowGap: 30,
				gridColumnGap: 30,
				gridSize: 1290,
				gridBorder: 30,
				gridBorderMinWidth: 30,
				selectedAd: 'none',
				sitebarWidth: '300',
				skyWidth: '130',
				superbannerSitebarMinWidth: '120',
				homeframeSkyWidth: '120',
				homeframeSitebarMinWidth: '160',
				minOutsideAdWidth: '0',
				adOverlap: false,
				topName: 'top',
				middleName: 'middle',
				rightName: 'right',
				leftName: 'left',
				minCols: 3,
				maxCols: 3,
				initialData: this.$initialData
			};
		},
		watch: {
			selectedAd: function (val) {
				document.querySelector('body').setAttribute('data-ad-type', val);
				this.setColCase();
			}
		},
		methods: {
			setColCase () {
				let minAdWidth, possibleContentWidth;

				switch (this.selectedAd) {
					case 'homeframe':
						minAdWidth = +this.homeframeSitebarMinWidth + +this.homeframeSkyWidth;
						this.minOutsideAdWidth = this.homeframeSitebarMinWidth;
						break;

					case 'wallpaper':
						minAdWidth = this.superbannerSitebarMinWidth;
						this.minOutsideAdWidth = this.superbannerSitebarMinWidth;
						break;

					case 'bridge':
					case 'double-sitebar':
						minAdWidth = this.skyWidth * 2;
						this.minOutsideAdWidth = this.skyWidth;
						break;

					case 'flagship':
					case 'sitebar':
						minAdWidth = this.sitebarWidth;
						this.minOutsideAdWidth = this.sitebarWidth;
						break;

					default:
						minAdWidth = 0;
						break;
				}

				if (this.selectedAd !== 'sitebar' && this.selectedAd !== 'double-sitebar') {
					this.gridBorderMinWidth = 30;
				}

				possibleContentWidth = document.documentElement.clientWidth - minAdWidth - this.gridBorderMinWidth * 2;

				this.colCount = Math.floor((possibleContentWidth + this.gridColumnGap) / (this.teaserWidth + this.gridColumnGap));
				if (this.adOverlap && this.selectedAd === 'sitebar' && this.colCount === 2) {
					minAdWidth = minAdWidth / 2;
					possibleContentWidth = document.documentElement.clientWidth - minAdWidth - this.gridBorderMinWidth * 2;
					this.colCount = Math.floor((possibleContentWidth + this.gridColumnGap) / (this.teaserWidth + this.gridColumnGap));
				}

				if (this.selectedAd === 'sitebar' || this.selectedAd === 'double-sitebar') {
					document.documentElement.style.setProperty('--grid-border', +this.gridBorder + 'px');
					let newGridBorder = Math.max(this.gridBorderMinWidth, Math.min(this.gridBorder, (document.documentElement.clientWidth - minAdWidth - this.colCount * this.teaserWidth - (this.colCount - 1) * this.gridColumnGap) / 2));

					document.documentElement.style.setProperty('--grid-border', newGridBorder + 'px');
				}

				document.documentElement.style.setProperty('--justify-grid-content', 'center');
				if (this.colCount > this.maxCols) {
					this.colCount = this.maxCols;
				} else if (this.colCount < this.minCols) {
					document.documentElement.style.setProperty('--justify-grid-content', 'start');

					if (this.selectedAd === 'sitebar' || this.selectedAd === 'double-sitebar') {
						document.documentElement.style.setProperty('--grid-border', this.gridBorderMinWidth + 'px');
					}
					this.colCount = this.minCols;
				}

				// col count changed
				if (this.colCount !== this.prevColCount) {
					this.prevColCount = this.colCount;

					document.querySelector('body').setAttribute('data-col-count', this.colCount);
					let event = new CustomEvent('colCountChanged', {
						bubbles: true,
						cancelable: true,
						detail: {
							colCount: this.colCount,
							source: 'App.vue'
						}
					});
					document.querySelector('body').dispatchEvent(event);
					document.documentElement.style.setProperty('--col-count', this.colCount);
				}
			},
			touchDetector () {
				return !!('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
			},
			getPermissionScripts () {
				if (window.PageConfig.tcf === false) {
					return;
				}

				let stage = window.PageConfig.stage.indexOf('qa') > -1 ? 'qa' : window.PageConfig.stage;

				if (stage === 'dev') {
					stage = 'qa';
				} else if (stage === 'prelive') {
					stage = 'live';
				}

				let permissionClientBaseURL = '//dl.' + window.SiteInfo.brandShort + '.' + window.SiteInfo.tld + '/permission/' + stage + '/v1/ppp/js/';
				let permissionClientURL = permissionClientBaseURL + 'permission-client.js';
				let permissionClientCompatURL = permissionClientBaseURL + 'permission-client-compat.js';

				this.addScript(permissionClientURL, () => {
					this.addScript(permissionClientCompatURL, () => {
						new CookielascheInterface();
					});
				});
			},
			addScript (scriptSrc, callback) {
				if (!scriptSrc) return;

				let head = document.getElementsByTagName('head')[0];
				let script = document.createElement('script');
				script.type = 'text/javascript';

				script.onload = (event) => {
					callback && callback();
				};

				script.src = scriptSrc;
				head.appendChild(script);
			},
			getAds () {
				AdServiceInterface.init('service', undefined, this.colCount);
				this.selectedAd = AdServiceInterface.serviceResponse.response.type;

				AdServiceHelper.listenEvent('initialize.end', () => {
					AdServiceInterface.logVersion();
				});

				/*
	               const makeBiddingAds = () => {
	                   const availableResponse = this.$initialData.availableResponse;
	                   PrebidInterface.init();
	                   if (response.rtb) {
	                       PrebidInterface.startBidding('initial');
	                   }

	                   if (availableResponse.placements.box_1 && availableResponse.placements.box_1.rtb) {
	                       PrebidInterface.startBidding('box_1');
	                   } else {
	                       AdServiceInterface.makeAd('box_1');
	                   }

	                   for (let i = 1; i <= 9; i++) {
	                       if (availableResponse.placements['box_' + i] && availableResponse.placements['box_' + i].rtb) {
	                           PrebidInterface.startBidding('box_' + i);
	                       } else {
	                           AdServiceInterface.makeAd('box_' + i);
	                       }
	                   }
	               };
	            */

				const makeAds = () => {
					for (let i = 1; i <= 10; i++) {
						AdServiceInterface.makeAd('box_' + i);
					}
				};

				const makeEventAds = (response) => {
					const parts = ['top', 'middle', 'left', 'right'];
					for (let part of parts) {
						const responsePart = response[part];
						if (responsePart) {
							let fillMe = '';
							let fallbackWidth = 0;
							let fallbackHeight = 0;

							// middle fallback is always billboard
							if (part === 'middle') {
								fallbackWidth = 970;
								fallbackHeight = 250;
							}

							if (AdServiceInterface.fallback) {
								this.fallbackWidth = true;
								if (responsePart.fallbackWidth) {
									fallbackWidth = responsePart.fallbackWidth;
								}
								if (responsePart.fallbackHeight) {
									fallbackHeight = responsePart.fallbackHeight;
								}

								if ((part === 'top' || part === 'middle') && typeof responsePart.fallback === 'object' && responsePart.fallback !== null) {
									fillMe = responsePart.fallback['column' + this.colCount + 'Ad'];
									const takeSmaller = (currentCols) => {
										const uimTag = AdServiceInterface.getUIMTag(part, fallbackWidth, fallbackHeight);
										let takeMe = responsePart.fallback['column' + currentCols + 'Ad'];
										if (!takeMe) {
											takeMe = responsePart.fallback['column' + (currentCols - 1) + 'Ad'];
										}
										return uimTag + takeMe;
									};

									document.addEventListener(
										'colCountChanged',
										(colChangeEvent) => {
											const colCase = colChangeEvent.detail.colCount;
											const takeMe = takeSmaller(colCase);
											AdServiceInterface.queHtml(part, uimTag + takeMe, true);
										},
										false
									);

									fillMe = takeSmaller(this.colCount);
								} else {
									fillMe = responsePart.fallback;
								}
							} else {
								if ((response.type === 'bridge' || response.type === 'flagship' || response.type === 'cinematic' || response.variant === 'dynamic') && part === 'middle') {
									this.dynamicMiddle = true;
								}
								if (response.skyVariant !== undefined && (response.skyVariant.length === 0 || response.skyVariant === 'dynamic')) {
									this.dynamicSides = true;
								}
								fillMe = responsePart.ad;
							}

							const uimTag = AdServiceInterface.getUIMTag(part, fallbackWidth, fallbackHeight);
							AdServiceInterface.queHtml(part, uimTag + fillMe, false, part);
						}
					}
				};

				const makeEventAdblockFallbackAds = () => {
					const callTop = ['wallpaper', 'homeframe'].includes(this.selectedAd);
					const callMiddle = ['billboard', 'flagship', 'bridge', 'cinematic'].includes(this.selectedAd);
					const callLeft = ['double-sitebar', 'homeframe'].includes(this.selectedAd);
					const callRight = ['double-sitebar', 'sitebar', 'wallpaper', 'homeframe'].includes(this.selectedAd);

					if (callTop) {
						// In adblocker case we have no top position
						const topAd = document.querySelector('[data-ac="top"]');
						topAd.parentElement.removeChild(topAd);

						this.minCols = 2; // 2 cols min cause we now have just a sitebar
						this.superbannerSitebarMinWidth = this.sitebarWidth; // overwriting old width value with sitebar value
					}

					if (callMiddle) {
						// TODO: refactoring, move to another place where it suits better
						// fixes "jumping" billboard
						const middleServiceSlot = document.querySelector('[data-service-slot="middle"]');
						if (middleServiceSlot) {
							middleServiceSlot.style.opacity = '0';
						}

						AdServiceHelper.listenEvent('ad.useiframecss', () => {
							if (middleServiceSlot) {
								middleServiceSlot.style.opacity = null;
							}
						});

						AdServiceInterface.makeAd('middle', true);
					}

					if (callLeft) {
						AdServiceInterface.makeAd('left', true);

						if (this.selectedAd === 'homeframe') {
							const leftAd = document.querySelector('[data-container="left"]');
							leftAd?.parentElement?.removeChild(leftAd);

							this.selectedAd = 'sitebar'; // so we get the right CSS from _grid.scss otherwise there would be a 120px blank space on the left side
						}
					}

					if (callRight) {
						AdServiceInterface.makeAd('right', true);
					}

					// remove acColor background
					AdServiceInterface.setAcBackgroundColor('');
				};

				const makeRotationAds = (response, isPrivateMode) => {
					const callMiddle = this.selectedAd === 'billboard';
					const callRight = this.selectedAd === 'sitebar';

					if (callMiddle) {
						if (isPrivateMode) {
							AdServiceInterface.makeAd('middle', true);
						} else {
							AdServiceInterface.queHtml('middle', response.ad, false, response.type);
						}
					}

					if (callRight) {
						if (isPrivateMode) {
							AdServiceInterface.makeAd('right', true);
						} else {
							AdServiceInterface.queHtml('right', response.ad, false, response.type);
						}
					}
				};

				const callAfterAdBlockDect = (isAdBlock) => {
					if (!isAdBlock) {
						if (window.initialData.serviceResponse.response.bg) {
							const { clickurl } = window.initialData.serviceResponse.response.bg;

							clickurl &&
								document.querySelectorAll('[data-ac], [data-container]').forEach((element) => {
									element.style.cursor = 'pointer';
									element.addEventListener('click', (event) => {
										window.open(clickurl, '_blank');
									});
								});
						}

						const callAfterPrivateModeDect = (isPrivateMode) => {
							AdServiceInterface.incrementAc();
							this.fallback = AdServiceInterface.showFallback();
							const response = AdServiceInterface.serviceResponse.response;

							if (isPrivateMode) {
								makeAds();
							} else {
								// if no event start prebid
								// makeBiddingAds();

								// there is no bidding right now
								makeAds();
							}

							if (response.middle || response.left || response.right) {
								makeEventAds(response);
							} else {
								makeRotationAds(response, isPrivateMode);
							}

							AdServiceInterface.makePartnerlinks();
							AdServiceInterface.makeVorteilswelt();
							AdServiceInterface.makeAd('tam');
						};

						AdServiceInterface.checkPrivateMode(callAfterPrivateModeDect);
					} else {
						this.fallback = true;
						makeEventAdblockFallbackAds();
						makeAds();
						AdServiceInterface.makePartnerlinks();
						AdServiceInterface.makeVorteilswelt();
						AdServiceInterface.makeAd('tam');
					}
				};

				AdServiceInterface.checkAdBlock(callAfterAdBlockDect);
			},
			getAdserviceScripts () {
				const serviceJsPath = AdServiceHelper.getScriptBaseUrl() + 'service.min.js';
				this.addScript(serviceJsPath, () => {
					this.getAds();
				});
			}
		},
		beforeCreate () {
			// disable the ability to kill the hp via an ad
			document.write = (str) => {
				if (window.location.href.includes('local')) {
					console.log('document.write ' + str);
				}
			};
			document.open = () => {
				if (window.location.href.includes('local')) {
					console.log('document.open');
				}
			};
			document.close = () => {
				if (window.location.href.includes('local')) {
					console.log('document.close');
				}
			};

			if (window.initialData.serviceResponse.response.right?.width) {
				this.superbannerSitebarMinWidth = window.initialData.serviceResponse.response.right.width;
			}
		},
		created () {
			window.AdService = window.AdService || [];
			this.selectedAd = document.querySelector('body').getAttribute('data-ad-type');
			window.addEventListener('resize', this.setColCase);
			this.setColCase();

			document.documentElement.style.setProperty('--sitebar-width', this.minOutsideAdWidth + 'px');
			document.documentElement.style.setProperty('--justify-grid-content', 'center');

			document.documentElement.style.setProperty('--screen-touchable', this.touchDetector());

			const response = window.initialData.serviceResponse.response;
			if (response.variant === 'sticky' || response.type === 'sitebar' || response.type === 'double-sitebar' || response.type === 'flagship' || response.type === 'wallpaper' || response.type === 'homeframe') {
				this.sticky = true;
			}

			if (!window.SiteInfo) {
				window.SiteInfo = {};
			}
			window.SiteInfo.brand = process.env.VUE_APP_BRAND;
			window.SiteInfo.loginPosition = document.querySelector('html').hasAttribute('data-header-login') ? 'header' : 'content';

			if (location.hostname !== 'localhost') {
				const regex = /\.([^.]+?)$/;
				window.SiteInfo.tld = regex.exec(location.hostname)[1];
			}
			// get Top Level Domain
			if (window.SiteInfo.tld === 'lan' || location.hostname === 'localhost' || /^\d+$/.test(window.SiteInfo.tld)) {
				if (window.SiteInfo.brand === 'gmx') {
					window.SiteInfo.tld = 'net';
				} else {
					window.SiteInfo.tld = 'de';
				}
			}

			window.SiteInfo.brandShort = '';
			switch (window.SiteInfo.brand) {
				case 'webde':
					window.SiteInfo.brandShort = 'web';
					break;
				case 'gmx':
					window.SiteInfo.brandShort = 'gmx';
					break;
				case 'einsundeins':
					window.SiteInfo.brandShort = '1und1';
					break;
				default:
					window.SiteInfo.brandShort = 'localhost';
			}

			if (window.SiteInfo.brand === 'webde') {
				window.SiteInfo.portalName = 'webde';
			} else if (window.SiteInfo.brand === 'gmx') {
				window.SiteInfo.portalName = 'gmx' + window.PageConfig.country;
			} else if (window.SiteInfo.brand === 'einsundeins') {
				window.SiteInfo.portalName = '1und1';
			}

			if (window.initialData.serviceResponse.response.type === 'cinematic' || window.initialData.serviceResponse.response.type === 'billboard') {
				this.minCols = 3;
			}

			const initializeTracking = () => {
				window.Tracking = new TrackingInterface();
				new TrackingConfig();
			};

			initializeTracking();
		},
		mounted () {
			this.$nextTick().then(() => {
				let event = new CustomEvent('pageReady', { bubbles: true, cancelable: true, detail: { source: 'App.vue' } });
				document.dispatchEvent(event);
			});

			// closure for scope
			(() => {
				const _this = this;
				window.addEventListener('load', (e) => {
					_this.getPermissionScripts();
					_this.getAdserviceScripts();
				});
			})();
		}
	};
</script>
